module.exports = __webpack_public_path__ + "img/simcard.2bf1cad1.svg";